module.exports = __webpack_public_path__ + "static/media/signzy-account-aggregator-logo.c94f6fd2.png";